// extracted by mini-css-extract-plugin
export default {"root":"Ds9X","name":"KKj6","id":"MjuV","id-prefix":"jnKD","idPrefix":"jnKD","divider":"hJNx","created-at-status":"JcmK","createdAtStatus":"JcmK","status":"vs10"};